// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1SCH8","title":"AfterBackImages_title__2F0Ir","images":"AfterBackImages_images__1z5Di"};